import React, { useCallback, useState } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import Modal from '@/components/elements/AutoBlockedModal/Modal';
import { useHistory } from '@/modules/core/hooks';

import { IRoleSetup } from '../role.types';

import { CopyPermissionsSection } from './RoleSetupForm/PermissionsSection';
import RoleSetupForm from './RoleSetupForm';
import { useRoleSetupStore } from './stores';


const RoleSetupAddModal = () => {
  const setState = useRoleSetupStore((state) => state.setState);
  const handleReset = useRoleSetupStore((state) => state.handleReset);
  const [visible, setVisible]  = useState(false);
  const handleToggleVisible = useCallback(() => {
    setVisible(!visible);
    handleReset();
  }, [handleReset, visible]);


  const history = useHistory();
  const handleSubmit = useCallback((data: IRoleSetup) => {

    setState(data); 
    history.push(ROUTES.ROLE_SETUP);
  } ,[history, setState]);
  return (
    <>
      <Modal testId='role-setup_add' visible={visible} onSetVisible={setVisible} wrapperStyle={{ zIndex: 10000 }}>
        <RoleSetupForm
          isModalMode
          onSubmit={handleSubmit}
          title={(
            <Text 
              size="2xl"
              weight={700}
              margin={{ bottom: 'l' }}
              style={{ lineHeight: '32px' }}>
              Create Role 
            </Text>
          )}

          footer={(
            <Box  margin={{top: 'l'}} direction="row" justify="end">
              <AppButton testId="create-role_cancel" width='160px' onClick={handleToggleVisible} buttonType='secondary'>
                Cancel
              </AppButton>
              <Box margin={{left: 's'}}>
                <AppButton testId="create-role_next" width='160px' type="submit" buttonType='primary'>
                  Next (1/2)
                </AppButton>
              </Box>
            </Box>
          )}
        >
          <CopyPermissionsSection 
            isEditMode
          />
        </RoleSetupForm>
      </Modal>
      <AppButton testId="create-role" width='150px' onClick={handleToggleVisible}>
        Create Role
      </AppButton>
    </>

  );
};

export default RoleSetupAddModal;